import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Container, Theme } from '@mui/material';

import { Images } from '../../../Themes';
import SpaceInfoBox from './SpaceInfoBox';
import SpaceSponsor from './SpaceSponsor';
import SpaceAffiliatesList from './SpaceAffiliatesList/SpaceAffiliatesList';
import { cloudinaryImageUrl } from '../../../Services/Cloudinary';
import useWidth from '../../../Hooks/useWidth';
import useSpace from '../../../Hooks/useSpace';

const HEADER_HEIGHT = 460;
const MOBILE_HEADER_HEIGHT = 230;

function Header({ section }: any) {
  const theme = useTheme() as Theme;
  const { space } = useSpace();
  const pictureUrl = cloudinaryImageUrl(section?.picture?.s3_key, 'h_460,q_auto,c_fill');
  const pictureOrPlaceholder = pictureUrl || Images.entities.defaultBanner;
  const isMobile = useWidth('down', 'sm');

  return (
    <Box
      component="header"
      sx={{ backgroundColor: theme.palette.secondary.light || theme.palette.grey[50] }}
    >
      <Box
        sx={{
          height: isMobile ? MOBILE_HEADER_HEIGHT : HEADER_HEIGHT,
          backgroundColor: theme.palette.grey[700],
          backgroundImage: `url(${pictureOrPlaceholder})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
      />

      {(section.title || section.content) && (
        <Container maxWidth="md">
          <Box
            sx={{
              mt: isMobile ? -5 : -10,
              pb: 1,
            }}
          >
            {space.sponsor && (
              <Box sx={{ mb: 2 }}>
                <SpaceSponsor sponsor={space.sponsor} />
              </Box>
            )}

            <SpaceInfoBox space={space} section={section} isMobile={isMobile} />
            <SpaceAffiliatesList affiliates={space.included?.affiliates} />
          </Box>
        </Container>
      )}
    </Box>
  );
}

export default Header;
